import script from "./artemisadsPageTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./artemisadsPageTitle.vue?vue&type=script&setup=true&lang=js"

import "./artemisadsPageTitle.vue?vue&type=style&index=0&id=c9929812&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9929812"]])

export default __exports__